<img [ngClass]="{'small': small, 'xsmall': xsmall, 'xxsmall': xxsmall}" src="{{ src }}" alt="{{ alt }}" *ngIf="src"> 
<mat-icon [ngClass]="{'small': small, 'xsmall': xsmall, 'xxsmall': xxsmall}" *ngIf="!src">account_circle</mat-icon>
